





import { Component, Provide, Vue } from "vue-property-decorator";

import HolidayLogosView from "@/components/apps-configuration/holidayLogos/holiday-logos-view.vue";

@Component({
  components: { HolidayLogosView },
})
export default class RootHotels extends Vue {
  @Provide() holidayLogosFolder = "main/configuration/holidayLogos";
}
